import { HttpInterceptorFn } from '@angular/common/http';
import { inject } from '@angular/core';
import { AuthService } from '../services/api/auth.service';

/**
 * Interceptor que agrega el token de sesión en el header Authorization
 * de las peticiones salientes cuando está presente.
 *
 * El sessionToken se almacena en memory (signal) y se obtiene:
 * 1. Desde /signin/authorize (inicial)
 * 2. Actualizado desde /signin/login cuando requiere MFA
 *
 * Header agregado: Authorization: Bearer <sessionToken>
 */
export const authorizeSessionInterceptor: HttpInterceptorFn = (req, next) => {
  const authService = inject(AuthService);
  const sessionToken = authService.sessionToken();

  if (sessionToken) {
    return next(
      req.clone({
        setHeaders: {
          Authorization: `Bearer ${sessionToken}`,
        },
      }),
    );
  }

  return next(req);
};
